const getParam = value => {
	switch (value) {
	case 'name-a-z':
	case 'name-z-a':
		return 'name'
	case 'domain-a-z':
		return 'domain'
	case 'newest':
	case 'oldest':
		return 'created'
	case 'status-active':
	case 'status-paused':
		return 'status'
	case 'campaign-type-a-z':
	case 'campaign-type-z-a':
		return 'type'
	case 'visitors-asc':
	case 'visitors-desc':
		return 'impressions'
	case 'leads-asc':
	case 'leads-desc':
		return 'conversions'
	case 'conversion-rate-asc':
	case 'conversion-rate-desc':
		return 'rate'
	default:
		return value
	}
}


export default (original, sort = 'name-a-z', useOriginal = false) => {

	const collator = new Intl.Collator(undefined, {
		numeric: true,
		sensitivity: 'base'
	})

	const array = useOriginal ? original : original.splice(0)
	let param = getParam(sort)
	switch (sort) {
	case 'name-a-z':
	case 'domain-a-z':
	case 'campaign-type-a-z':
		array.sort((a, b) => {
			return collator.compare(a[param], b[param])
		})
		break
	case 'name-z-a':
	case 'campaign-type-z-a':
			array.sort((a, b) => {
				return collator.compare(a[param], b[param])
			}).reverse()
		break
	case 'newest':
	case 'status-paused':
		array.sort((a, b) => {
			if (a[param] < b[param]) {
				return 1
			} else if (a[param] > b[param]) {
				return -1
			}
			return 0
		})
		break
	case 'oldest':
	case 'status-active':
		array.sort((a, b) => {
			if (a[param] > b[param]) {
				return 1
			} else if (a[param] < b[param]) {
				return -1
			}
			return 0
		})
		break
	case 'visitors-asc':
	case 'leads-asc':
	case 'conversion-rate-asc':
		array.sort((a, b) => {
			if (a.analytics_data[param] > b.analytics_data[param]) {
				return 1
			} else if (a.analytics_data[param] < b.analytics_data[param]) {
				return -1
			}
			return 0
		})
		break
	case 'visitors-desc':
	case 'leads-desc':
	case 'conversion-rate-desc':
		array.sort((a, b) => {
			if (a.analytics_data[param] < b.analytics_data[param]) {
				return 1
			} else if (a.analytics_data[param] > b.analytics_data[param]) {
				return -1
			}
			return 0
		})
		break
	}

	return array
}
